// src/app/%28admin%29/%28others-pages%29/blank/page.tsx
import { createFileRoute } from '@tanstack/react-router'
import PageBreadcrumb from "@/components/common/PageBreadCrumb";
import { Metadata } from "next";
import { ROUTES } from "@/config/routes";
import React from "react";

export const metadata: Metadata = {
  title: "Next.js Blank Page | TailAdmin - Next.js Dashboard Template",
  description: "This is Next.js Blank Page TailAdmin Dashboard Template",
};

function BlankPage() {
  return (
    <div>
           <PageBreadcrumb items={[
  { label: 'Dashboard', href: ROUTES.ADMIN_DASHBOARD.path },
  { label: 'Line Chart', href: '/line-chart', active: true }
]} />
      <div className="min-h-screen rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <div className="mx-auto w-full max-w-[630px] text-center">
          <h3 className="mb-4 font-semibold text-gray-800 text-theme-xl dark:text-white/90 sm:text-2xl">
            Card Title Here
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 sm:text-base">
            Start putting content on grids or panels, you can also use different
            combinations of grids.Please check out the dashboard and other pages
          </p>
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/(admin)/(others-pages)/blank/')({
  component: BlankPage,
})
